export const GET_MOVIES = "GET_MOVIES";
export const SET_MOVIES = "SET_MOVIES";
export const SELECT_MOVIE = "SELECT_MOVIE";
export const CLEAR_MOVIES = "CLEAR_MOVIES";

export const API = "API";
export const API_START = "API_START";
export const API_END = "API_END";

export const SET_AUTH = "SET_AUTH";
export const CLEAR_AUTH = "CLEAR_AUTH";
export const FAIL_AUTH = "FAIL_AUTH";
export const SUCCESS_AUTH = "SUCCESS_AUTH";

export const SET_TOKEN = "SET_TOKEN";
export const CLEAR_TOKEN = "CLEAR_TOKEN";
export const GET_TOKEN = "GET_TOKEN";

export const ACTIVE_MENU_ITEM = "ACTIVE_MENU_ITEM";